module.exports = __webpack_public_path__ + "img/niubiz.cce9b752.png";